"use client"
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import logo from '../../../public/logo.jpg';
import Image from 'next/image';
import { Icon } from "@iconify/react"
import { useRouter } from 'next/navigation';
import { makeStyles } from '@mui/styles';
import { getCookies, deleteCookie } from 'cookies-next';
import { useAuthContext } from '@/auth/hooks';
import { AuthContext } from '@/contexts/auth-context';
import { Avatar } from '@mui/material';
import { formatPhoneNumber } from '@/helpers/formatter';
import { useConfig } from '@/contexts/config-context';
import ModalLogin from '../modals/modal-login';
import { useEffect, useState } from 'react';
import hexToRgba from 'hex-to-rgba';
import { FaTrophy } from 'react-icons/fa';
import { RxHamburgerMenu } from 'react-icons/rx'
import { IoMdClose, IoMdHome, IoIosPerson } from 'react-icons/io';
import { FiAward } from 'react-icons/fi'
import { FaRegRectangleList } from "react-icons/fa6";
import { IoTicketOutline, IoGiftOutline, IoExitOutline } from "react-icons/io5";
import { GiCartwheel } from "react-icons/gi";

let navItemsInitial = [
    {
        title: "Home",
        href: "/",
        icon: <IoMdHome color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Perfil",
        href: "/profile",
        icon: <IoIosPerson color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Afiliados",
        href: "/affiliate",
        icon: <FiAward color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Campanhas",
        href: "/campaigns",
        icon: <FaRegRectangleList color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Ganhadores",
        href: "/winners",
        icon: <FaTrophy color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Meus títulos",
        href: "/my-tickets",
        icon: <IoTicketOutline color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Caixas surpresa",
        href: "/mistery-box",
        icon: <IoGiftOutline color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Roletas",
        href: "/wheel-luck",
        icon: <GiCartwheel color='white' size={20} style={{ marginRight: 10 }} />
    },
    {
        title: "Termos de uso",
        href: "/terms",
        icon: <FaRegRectangleList color='white' size={20} style={{ marginRight: 10 }} />
    }
];


function Header({
    color = "black"
}) {

    const configData = useConfig();

    const useStyles = React.useMemo(() => makeStyles((theme) => ({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            color: 'black'
        },
        title: {
            flexGrow: 1,
            color: 'black'
        },
        appBarTransparent: {
            backgroundColor: `${configData?.appearance?.client_primary_color ? hexToRgba(configData?.appearance?.client_primary_color, '0.8') : 'rgba(0,0,0,.7)'} !important`,
            backdropFilter: 'blur(8px) !important',
            WebkitBackdropFilter: 'blur(8px) !important'
        },
        appBarSolid: {
            backgroundColor: configData?.appearance?.client_primary_color + '!important'
        }
    })), [configData]);


    const { user } = React.useContext(AuthContext);
    const [showModalLogin, setShowModalLogin] = React.useState(false);
    const [navItems, setNavItems] = React.useState(navItemsInitial);

    const classes = useStyles();
    const router = useRouter();
    const [navBackground, setNavBackground] = React.useState('appBarSolid');
    const context = React.useContext(AuthContext)

    const navRef = React.useRef()
    navRef.current = navBackground
    // const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    React.useEffect(() => {
        if (typeof window == "undefined") {
            return
        }
        const handleScroll = () => {
            const show = window.scrollY < 100
            if (show) {
                setNavBackground('appBarSolid')
            } else {
                setNavBackground('appBarTransparent')
            }
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    React.useEffect(() => {
        setNavItems(prev => {
            const filtered = prev.filter(item => item.title !== "Login" && item.title !== "Sair");

            let newItems = [...filtered];


            // Adiciona o item de login/logout
            newItems.push({
                title: user == null ? "Login" : "Sair",
                action: () => {
                    if (user == null) {
                        setShowModalLogin(true);
                    } else {
                        window.localStorage.removeItem("token");
                        window.location.reload();
                    }
                },
                type: "button",
                icon: <IoExitOutline style={{ marginRight: 10 }} color='white' fontSize={20} />
            });

            return newItems;
        });
    }, [user]);

    const drawer = (
        <Box className="menu-layout-background" sx={{ textAlign: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ maxWidth: 700, margin: "auto" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <div className='flex justify-center items-center ml-2' >
                        <img width={150} height={120} src={configData?.logo_path} className='my-4' />
                    </div>
                    {
                        configData?.second_logo_path &&
                        <div className='flex justify-center items-center ml-2' >
                            <img width={150} height={120} src={configData?.second_logo_path} className='my-4' />
                        </div>
                    }
                    <IconButton onClick={handleDrawerToggle} sx={{ color: "rgb(33, 43, 54)" }}>
                        <IoMdClose size={40} />
                    </IconButton>
                </Box>


                <List className='menu-layout-background'>
                    <div style={{ height: 1, width: "100%", backgroundColor: "rgba(108, 117, 125, 0.3)" }} />
                    {
                        context.user && <>
                            <Box display="flex" gap={2} mt={3} mb={3} alignItems="center">
                                <Avatar
                                    sx={{
                                        borderRadius: 1,
                                        width: 70,
                                        height: 70
                                    }} src='/user.jpg' />
                                <Box display="flex" flexDirection="column" textAlign={"left"}>
                                    <Typography color={"white"} fontWeight="bold" variant='h6'>{context.user?.name}</Typography>
                                    <Typography color={"white"}>{formatPhoneNumber(context.user?.phone)}</Typography>
                                </Box>
                            </Box>
                            <div style={{ height: 1, width: "100%", backgroundColor: "rgba(108, 117, 125, 0.3)" }} />
                        </>
                    }
                    {navItems.map((item, index) => {
                        if (item.type == "button") {
                            return (
                                <Button key={index} onClick={item.action} fullWidth variant='contained' color='primary'>
                                    {
                                        typeof item.icon == "string" ?
                                            <Icon icon={item.icon} style={{ marginRight: 10 }} fontSize={20} />
                                            :
                                            item.icon
                                    }
                                    {item.title}</Button>
                            );
                        }
                        return (
                            <div key={"a" + index}>
                                <ListItem
                                    onClick={() => {
                                        router.push(item.href);
                                        handleDrawerToggle();
                                    }}
                                    disablePadding
                                    className='menu-layout-background'
                                    sx={{
                                        // background: "black",
                                        py: 1
                                    }}>
                                    <ListItemButton sx={{ color: "white" }}>
                                        <Divider sx={{ color: "blue", bgcolor: 'blue' }} />

                                        {
                                            typeof item.icon == "string" ?
                                                <Icon icon={item.icon} style={{ marginRight: 10 }} fontSize={20} />
                                                :
                                                item.icon
                                        }
                                        <b>{item.title}</b>
                                    </ListItemButton>
                                </ListItem>
                                <div style={{ height: 1, width: "100%", backgroundColor: "rgba(108, 117, 125, 0.3)" }} />
                            </div>
                        )
                    })}
                </List>
            </Box>
        </Box>
    );

    const container = typeof window !== "undefined" ? () => window.document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }} >
            {
                showModalLogin && <ModalLogin open={showModalLogin} onClose={() => setShowModalLogin(false)} />
            }
            <CssBaseline />
            <div style={{
                zIndex: 100,
                position: "fixed",
                top: 0,
                left: 0,
                height: 65,
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <AppBar component="nav" position="fixed"
                    className={
                        navBackground == 'appBarTransparent' ? classes.appBarTransparent : classes.appBarSolid
                    }
                    style={{
                        zIndex: 999,
                        backgroundColor: navBackground == 'appBarTransparent' ? "transparent" : color,
                    }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",

                    }}>
                        <div style={{
                            maxWidth: 600,
                            width: "100%",

                        }}>
                            <Toolbar
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",

                                }}
                                variant='dense' style={{ height: 65 }} className='flex justify-between'>

                                <div onClick={() => router.push("/")} >
                                    <img width={130} height={100} src={configData?.logo_path} />
                                </div>
                                {
                                    configData?.second_logo_path &&
                                    <div onClick={() => router.push("/")} >
                                        <img width={130} height={100} src={configData?.second_logo_path} />
                                    </div>
                                }

                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={handleDrawerToggle}
                                    sx={{ mr: 2, color: 'white' }}
                                >
                                    <RxHamburgerMenu />
                                </IconButton>
                            </Toolbar>
                        </div>
                    </div>

                </AppBar>
            </div>

            <div style={{
                position: "absolute",
                width: "100%",
                height: 20,
                zIndex: 50,
                backgroundColor: color,
                marginTop: 65
            }}
                className='menu-layout-background'
            />
            <nav>
                <Drawer
                    anchor='top'

                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: "100%" },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
        </Box>
    );
}

export default Header;